module.exports = __webpack_public_path__ + "assets/headspace-2f89bdeb89ac57159da19a3f3333082f.svg";